import { Routes } from '@angular/router';

import { OurExpertiseComponent } from './our-expertise.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: OurExpertiseComponent,
    children: []
  }
];


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+our-expertise/our-expertise.routes.ts